import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { buildConsentPayload, clearPendingConsent } from '../lib/legal';
import { updateProfile } from '../lib/database';

// PB-002 — Backstop legale per il login OAuth: se un utente entra con un provider
// social (es. Google) ma il profilo non ha ancora il consenso Privacy/Termini
// registrato (es. consenso "pending" perso nel redirect), ProtectedRoute lo manda
// qui. L'utente NON entra nell'app finché non accetta.
function ConsentGate() {
  const { user, profile, setProfile } = useAuth();
  const [accepted, setAccepted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Nessuna sessione → torna al login. Consenso già presente → entra.
  if (!user) return <Navigate to="/" replace />;
  if (profile?.terms_accepted_at) return <Navigate to="/athlete" replace />;

  const handleAccept = async () => {
    if (!accepted) { setError('Per continuare devi accettare Privacy e Termini.'); return; }
    setSaving(true); setError('');
    try {
      const payload = buildConsentPayload();
      await updateProfile(user.id, payload);
      clearPendingConsent();
      if (profile) setProfile({ ...profile, ...payload });
      navigate('/athlete', { replace: true });
    } catch (e) {
      setError('Errore nel salvataggio. Riprova.');
      setSaving(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f7fa', padding: '20px' }}>
      <div style={{ maxWidth: '380px', width: '100%', background: '#fff', borderRadius: '16px', padding: '28px 24px', boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
        <h1 style={{ fontSize: '22px', fontWeight: 800, color: '#111827', margin: '0 0 8px' }}>Ancora un passaggio</h1>
        <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 20px', lineHeight: 1.5 }}>
          Per usare Uptra devi confermare di aver letto l'Informativa Privacy e di accettare i Termini di utilizzo.
        </p>

        <label style={{ display: 'flex', gap: '8px', alignItems: 'flex-start', fontSize: '13px', color: '#374151', margin: '0 0 16px', lineHeight: 1.4 }}>
          <input type="checkbox" checked={accepted} onChange={(e) => setAccepted(e.target.checked)} style={{ marginTop: '2px', flexShrink: 0 }} />
          <span>
            Dichiaro di aver letto l'<Link to="/privacy" target="_blank" rel="noopener noreferrer">Informativa Privacy</Link> e
            accetto i <Link to="/termini" target="_blank" rel="noopener noreferrer">Termini di utilizzo</Link> di Uptra.
          </span>
        </label>

        {error && <div style={{ color: '#b91c1c', fontSize: '13px', margin: '0 0 12px' }}>{error}</div>}

        <button
          type="button"
          onClick={handleAccept}
          disabled={saving || !accepted}
          style={{ width: '100%', padding: '14px', background: '#667eea', color: '#fff', border: 'none', borderRadius: '12px', fontSize: '16px', fontWeight: 700, cursor: saving || !accepted ? 'not-allowed' : 'pointer', opacity: saving || !accepted ? 0.5 : 1 }}
        >
          {saving ? 'Salvataggio…' : 'Continua'}
        </button>
      </div>
    </div>
  );
}

export default ConsentGate;
